import styled from 'styled-components';
import { layout, typography, transitions, breakpoints } from '../../theme';

export const Wrapper = styled.div`
  margin-left: ${props => (props.isActive ? 26 : 0)}vw;
  margin-top: ${layout.SPACING}rem;
  margin-bottom: ${props => (props.isActive ? layout.SPACING : 0)}rem;
  overflow: visible;
  position: relative;
  transition: height ${transitions.COLOR}, margin ${transitions.COLOR};
  width: 34vw;

  @media ${breakpoints.MOBILE__MQ} {
    margin-left: auto;
    margin-right: auto;
    max-width: 60rem;
    width: 100%;
  }

  h2,
  h3 {
    margin: 0;
    text-align: left;
  }

  h3,
  ul {
    font-size: ${typography.FONT_SIZE__SMALL}rem;
  }

  h2 {
    margin-bottom: ${typography.LINE_HEIGHT}rem;
  }
`;

export const InnerWrapper = styled.div`
  left: 0;
  opacity: ${props => (props.isActive ? 1 : 0)};
  position: absolute;
  top: 0;
  transition: opacity ${transitions.COLOR}, visibility ${transitions.COLOR};
  visibility: ${props => (props.isActive ? 'visible' : 'hidden')};
  width: 100%;
`;
